import { useState } from 'react';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Container,
	Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FAQ_ITEMS } from './constants';

const FAQ = () => {
	const [expanded, setExpanded] = useState(false);

	return (
		<Box
			component="section"
			sx={{
				py: { xs: 7, md: 10 },
				bgcolor: 'background.paper',
				borderTop: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Container maxWidth="md">
				<Box sx={{ textAlign: 'center', mb: { xs: 4, md: 5 } }}>
					<Typography
						variant="overline"
						color="warning.main"
						sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
					>
						FAQ
					</Typography>
					<Typography variant="h4" component="h2" sx={{ mt: 1, fontWeight: 700 }}>
						Common questions
					</Typography>
				</Box>

				{FAQ_ITEMS.map((item, index) => (
					<Accordion
						key={item.question}
						expanded={expanded === index}
						onChange={() => setExpanded(expanded === index ? false : index)}
						elevation={0}
						sx={{
							border: '1px solid',
							borderColor: 'divider',
							'&:not(:last-child)': { mb: 1.5 },
							'&:before': { display: 'none' },
							borderRadius: '12px !important',
						}}
					>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography sx={{ fontWeight: 600 }}>{item.question}</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Typography color="text.secondary" sx={{ lineHeight: 1.75 }}>
								{item.answer}
							</Typography>
						</AccordionDetails>
					</Accordion>
				))}
			</Container>
		</Box>
	);
};

export default FAQ;
